// extracted by mini-css-extract-plugin
export default {"pageHeaderContainer":"ErrorPage_pageHeaderContainer__kXc0r","buttonContainer":"ErrorPage_buttonContainer__kRv33"};